/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Kuvaus',
    END_DATE: 'Kunnes',
    ID: 'Id',
    OBJECTIVE: 'Tavoite',
    REWARD: 'Palkinto',
    START_DATE: 'Koska'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Kertynyt arvo',
    ACTIVES: 'Varat',
    AT: 'Osoitteessa',
    COUPON: 'Kuponki',
    CREATED: 'Luotu',
    DAY_VALUE: 'Arvopäivä',
    FAIL: 'Epäonnistuminen',
    FINISHED: 'Valmis',
    HISTORY: 'Historia',
    IN_PROGRESS: 'Käynnissä',
    MONETARY_REWARD: 'Premium-arvo',
    NR_ACCESSES: 'Käyttökertojen määrä',
    NR_NEW_CLIENTS: 'Uudet asiakkaat',
    NR_ORDERS: 'Tilausten lukumäärä',
    OBJECTIVE: 'Tavoite',
    OBJECTIVE_VALUE: 'Tavoitearvo',
    OFFER: 'Tarjous',
    OPEN: 'Avaa',
    REMUNERATION: 'Palkkaus',
    REWARD_TYPE: 'Palkkiotyyppi',
    REWARD_TYPES: 'Palkintotyypit',
    SALES: 'Myynti',
    SALES_BRANDS: 'Tuotemerkkien myynti (€)',
    SALES_BRANDS_QTY: 'Tuotemerkkien myynti (määrä)',
    SALES_CATEGORY: 'Myyntiluokka (€)',
    SALES_CATEGORY_QTY: 'Luokan myynti (määrä)',
    SALES_COMMISSIONS: 'Myyntipalkkiot',
    SALES_PRODUCTS: 'Tuotemyynti (€)',
    SALES_PRODUCTS_QTY: 'Tuotteiden myynti (määrä)',
    SUCCESS: 'Menestys',
    TO: '{0} kunnes {1}',
    TODAY: 'Tänään'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Ei aktiivisia haasteita (vielä)',
    CHALLANGES_TITLE: 'Ei haasteita.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
